import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'BLOG/AUTHORS';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetBlogAuthors(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const response = yield client.post('/merchant/blog/getAuthorList', {
      data: { site: siteId },
    });
    const res = response.result.authors;

    yield put(actions.loadSuccess(res));
    resolve && resolve(res);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
